import { render, staticRenderFns } from "./VRequest.vue?vue&type=template&id=318c79af&scoped=true"
import script from "./VRequest.vue?vue&type=script&lang=ts"
export * from "./VRequest.vue?vue&type=script&lang=ts"
import style0 from "./VRequest.vue?vue&type=style&index=0&id=318c79af&prod&lang=scss&scoped=true"
import style1 from "./VRequest.vue?vue&type=style&index=1&id=318c79af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318c79af",
  null
  
)

export default component.exports